module.exports = __webpack_public_path__ + "img/wxlogo.b8ae2220.png";